import Core from 'src/Core'
import Logger from 'src/initializers/Logger'

export default (superclass) => class extends superclass {
  getOffers () {
    return Core.publicWrapper({
      name: 'getOffers',
      arguments: arguments,
      parameters: ['onSuccess', 'onFailure', 'onComplete'],
    })
  }

  getPot () {
    return Core.publicWrapper({
      name: 'getPot',
      arguments: arguments,
      parameters: ['onSuccess', 'onFailure', 'onComplete'],
    })
  }

  getPotRefunds () {
    return Core.publicWrapper({
      name: 'getPotRefunds',
      arguments: arguments,
      parameters: ['transferPaymentId', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'transferPaymentId', presence: true, type: 'number', nan: false },
      ]
    })
  }

  updatePaymentInformation () {
    Logger.warn('(DeprecationWarning) updatePaymentInformation is deprecated - use createTransferWithPaymentInformation')
    const name = 'updatePaymentInformation'
    return Core.publicWrapper({
      name,
      arguments: arguments,
      parameters: ['firstName', 'lastName', 'iban', 'email', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'firstName', type: 'string', presence: true },
        { name: 'lastName',  type: 'string', presence: true },
        { name: 'iban',      type: 'string' },
        { name: 'email',     type: 'string' },
      ]
    }, async function wrapped (params) {
      Core.validateParam(name, params.iban || params.email, {
        name: 'iban/email',
        presence: true,
        message: 'missing either parameter iban or email',
      })
      await Core.execute('Api', 'updatePaymentInformation', params)
    })
  }

  createTransferPayment () {
    Logger.warn('(DeprecationWarning) createTransferPayment is deprecated - use createTransferWithPaymentInformation')
    return Core.publicWrapper({
      name: 'createTransferPayment',
      arguments: arguments,
      parameters: ['onSuccess', 'onFailure', 'onComplete'],
    })
  }

  createTransferWithPaymentInformation () {
    const name = 'createTransferWithPaymentInformation'
    return Core.publicWrapper({
      name,
      arguments: arguments,
      parameters: ['firstName', 'lastName', 'iban', 'email', 'rememberInformation', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'firstName', type: 'string' },
        { name: 'lastName',  type: 'string' },
        { name: 'iban',      type: 'string' },
        { name: 'email',     type: 'string' },
        { name: 'rememberInformation', type: 'boolean', presence: true },
      ],
    })
  }

  forgetPaymentInformations () {
    return Core.publicWrapper({
      name: 'forgetPaymentInformations',
      arguments: arguments,
      parameters: ['onSuccess', 'onFailure', 'onComplete'],
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Dematerialisation.js